<template>
  <ListEditor
    :buttonText="buttonText"
    component="SingleListBoxFields"
    :disableAddListItem="disableAddListItem"
    :handleAddListItem="handleAddAttribute"
    :handleChangeListItem="handleChangeListItem"
    :handleRemoveListItem="handleRemoveAttribute"
    :headerText="control.label"
    :listItems="value"
    :tooltip="getTooltip()"
  />
</template>
<script>
import { clone } from 'lodash';
import DynamicControlsMixin from 'components/DynamicControls/mixins/DynamicControlsMixin';
import ListEditor from 'client/components/FormValidation/ListEditor';

export default {
  name: 'DynamicControlsSingleListBox',

  components: {
    ListEditor,
  },

  mixins: [
    DynamicControlsMixin,
  ],

  inject: ['$validator'],

  props: {
    value: {
      default: () => [],
      type: Array,
    },
  },

  data() {
    return {
      addingValue: false,
    };
  },

  computed: {
    // policies provides customization of specific displayTypes through displayOptions.
    buttonText(state) {
      const { buttonText, displayOptions } = state.control;
      const defaultText = 'add new custom attribute';

      return (displayOptions && displayOptions.buttonText) || buttonText || defaultText;
    },

    /**
     * Disable the add button when adding a new attribute until the new
     * attribute has a value, or it is removed.
     */
    disableAddListItem() {
      const value = (this.value && this.value[0]) || '';

      if (this.addingValue && !value) {
        return true;
      }

      return false;
    },
  },

  methods: {
    handleAddAttribute() {
      const clonedValues = clone(this.value);
      clonedValues.splice(0, 0, '');
      this.handleValueChange(this.control.id, clonedValues);
      this.addingValue = true;
    },

    handleChangeListItem(index, listItem) {
      const clonedValues = clone(this.value);
      clonedValues[index] = listItem;
      this.handleValueChange(this.control.id, clonedValues);

      if (this.addingValue && index === 0 && !this.disableAddListItem) {
        this.addingValue = false;
      }
    },

    handleRemoveAttribute(index) {
      const clonedValues = clone(this.value);
      clonedValues.splice(index, 1);
      this.handleValueChange(this.control.id, clonedValues);

      if (this.addingValue && index === 0) {
        this.addingValue = false;
      }
    },
  },
};
</script>
